"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactGa = require("react-ga");

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _brightDates = require("bright-dates");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _lodash = _interopRequireDefault(require("lodash.get"));

require("react-day-picker/lib/style.css");

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _Cross = _interopRequireDefault(require("../Icons/Cross"));

var _HeaderMonthPanel = _interopRequireDefault(require("./HeaderMonthPanel"));

var _HeaderYearPanel = _interopRequireDefault(require("./HeaderYearPanel"));

var _HeaderDayPickerPanel = _interopRequireDefault(require("./HeaderDayPickerPanel"));

var _WhiteOutlineButton = _interopRequireDefault(require("../Button/WhiteOutlineButton"));

var _getYearRangeChunks = _interopRequireDefault(require("./utils/getYearRangeChunks"));

var _getYearRangeIndex = _interopRequireDefault(require("./utils/getYearRangeIndex"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t&:not(.active) {\n\t\tcolor: ", ";\n\t\t&:hover {\n\t\t\tcolor: ", ";\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n\tpadding: ", " ", " 0 ", ";\n\n\t&.active {\n\t\tfont-family: ", ";\n\t\tfont-weight: bold;\n\t}\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n\tbackground: ", ";\n\tborder-color: ", ";\n\tposition: absolute;\n\ttop: 12px;\n\tright: ", ";\n\tpadding: ", ";\n\n\t&:hover {\n\t\tcolor: ", ";\n\t\tbackground: ", ";\n\t\tborder-color: ", ";\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: space-evenly;\n\ttext-align: center;\n\tmargin: 0 40px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: relative;\n\tmin-height: 385px;\n\tdisplay: flex;\n\tflex-direction: column;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var DayPickerWrapper = _styledComponents.default.div(_templateObject());

DayPickerWrapper.displayName = 'DayPickerWrapper';

var SelectedDatesContainer = _styledComponents.default.div(_templateObject2());

SelectedDatesContainer.displayName = 'SelectedDatesContainer';
var CloseButton = (0, _styledComponents.default)(_WhiteOutlineButton.default)(_templateObject3(), _colors.default.secondary, _colors.default.white, _colors.default.white, _spacing.default.s1, _spacing.default.s1, _colors.default.secondaryDark, _colors.default.white, _colors.default.white);
CloseButton.displayName = 'CloseButton';
var SelectedDate = (0, _styledComponents.css)(_templateObject4(), _colors.default.textColor, _spacing.default.s2, _spacing.default.s1, _spacing.default.s1, _vars.default.fontStackBold);

var StartDateContainer = _styledComponents.default.div(_templateObject5(), SelectedDate, _colors.default.link, _colors.default.linkHover);

StartDateContainer.displayName = 'StartDateContainer';

var EndDateContainer = _styledComponents.default.div(_templateObject6(), SelectedDate);

EndDateContainer.displayName = 'EndDateContainer';
var YEAR = 'year';
var MONTH = 'month';
var CALENDAR = 'calendar';

var friendlyDate = function friendlyDate(selectedDate) {
  return (0, _brightDates.formatDate)(selectedDate, ['friendlyShort', 'year']);
};

var DayPickerPanel =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DayPickerPanel, _React$Component);

  function DayPickerPanel(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var yearRangeChunks = (0, _getYearRangeChunks.default)(props.yearRange.min, props.yearRange.max, props.yearsToDisplay);
    var yearRangeIndex = (0, _getYearRangeIndex.default)(yearRangeChunks, props.year);
    _this.state = {
      year: props.year,
      month: props.month,
      view: props.view,
      startDateClicked: false,
      range: props.range,
      yearRangeIndex: yearRangeIndex
    };
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = DayPickerPanel.prototype;

  _proto.onSelectedDay = function onSelectedDay(newRange) {
    var _this2 = this;

    var _this$props = this.props,
        dateRange = _this$props.dateRange,
        onApply = _this$props.onApply;

    if (!dateRange) {
      return this.setState({
        range: newRange
      }, function () {
        _this2.applyDatesGaEvent('selected');

        onApply(newRange);
      });
    }

    this.setState({
      range: newRange,
      startDateClicked: false
    });
  };

  _proto.setMonth = function setMonth(month) {
    var year = this.state.year;
    var _this$props2 = this.props,
        onMonthSelected = _this$props2.onMonthSelected,
        close = _this$props2.close;

    if (this.isMonthOnly()) {
      onMonthSelected(month, year);
      close();
      return;
    }

    this.setState({
      month: month
    });
  };

  _proto.setYear = function setYear(year) {
    this.setState({
      year: year
    });
  };

  _proto.setYearRangeIndex = function setYearRangeIndex(newIndex) {
    this.setState({
      yearRangeIndex: newIndex
    });
  };

  _proto.isMonthOnly = function isMonthOnly() {
    return typeof this.props.onMonthSelected === 'function';
  };

  _proto.switchBackToCalendarView = function switchBackToCalendarView() {
    this.setState({
      view: CALENDAR
    });
  };

  _proto.applyDatesGaEvent = function applyDatesGaEvent(selectedDay) {
    var _this$props3 = this.props,
        _this$props3$GA = _this$props3.GA,
        category = _this$props3$GA.category,
        actionId = _this$props3$GA.actionId,
        dateRange = _this$props3.dateRange,
        recordValue = _this$props3.recordValue;
    var _this$state$range = this.state.range,
        from = _this$state$range.from,
        to = _this$state$range.to;
    var actionEvent = selectedDay ? 'Set' : 'Apply';

    if (category) {
      var label = dateRange ? (0, _brightDates.formatDate)(from, 'friendlyShort') + " - " + (0, _brightDates.formatDate)(to, 'friendlyShort') + " " + (0, _brightDates.formatDate)(to, 'year') : (0, _brightDates.formatDate)(from, 'friendlyShort') + " " + (0, _brightDates.formatDate)(from, 'year');
      (0, _reactGa.event)(_objectSpread({
        category: category,
        action: actionId + " - " + actionEvent
      }, recordValue ? {
        label: label
      } : {}));
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props4 = this.props,
        onCancel = _this$props4.onCancel,
        onClear = _this$props4.onClear,
        yearRange = _this$props4.yearRange,
        yearsToDisplay = _this$props4.yearsToDisplay,
        dateRange = _this$props4.dateRange,
        _onApply = _this$props4.onApply,
        disabledDays = _this$props4.disabledDays,
        shortcuts = _this$props4.shortcuts,
        close = _this$props4.close,
        GA = _this$props4.GA;
    var _this$state = this.state,
        range = _this$state.range,
        view = _this$state.view,
        startDateClicked = _this$state.startDateClicked,
        month = _this$state.month,
        year = _this$state.year,
        yearRangeIndex = _this$state.yearRangeIndex;
    var startDate = (0, _lodash.default)(range, 'from');
    var endDate = (0, _lodash.default)(range, 'to');
    var activeStart = !startDate && !endDate || startDateClicked;
    var activeEnd = startDate && !endDate;

    if (!activeStart && !activeEnd) {
      activeEnd = true;
    }

    var selectedDayTextFrom = startDate ? friendlyDate(startDate) : 'Choose start date';
    var selectedDayTextTo = endDate ? friendlyDate(endDate) : 'Choose end date';
    return _react.default.createElement(DayPickerWrapper, {
      "data-testid": "daypicker-panel"
    }, _react.default.createElement(SelectedDatesContainer, null, dateRange && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StartDateContainer, {
      className: activeStart ? 'active' : '',
      onClick: function onClick() {
        _this3.setState({
          startDateClicked: true
        });
      }
    }, "Start: ", selectedDayTextFrom), _react.default.createElement(EndDateContainer, {
      className: activeEnd ? 'active' : ''
    }, "End: ", selectedDayTextTo))), view === MONTH && _react.default.createElement(_HeaderMonthPanel.default, {
      year: year,
      month: month,
      yearRange: yearRange,
      onCancelClick: function onCancelClick() {
        _this3.setState({
          view: CALENDAR
        });

        (0, _reactGa.event)({
          category: GA.category,
          action: GA.actionId + " - Cancel Month"
        });
      },
      setMonth: this.setMonth,
      switchBackToCalendarView: this.switchBackToCalendarView,
      setYear: this.setYear,
      GA: GA,
      isViewingCurrentYear: startDate && startDate.getFullYear() === year,
      isMonthOnly: this.isMonthOnly()
    }), view === YEAR && _react.default.createElement(_HeaderYearPanel.default, {
      year: year,
      yearRangeIndex: yearRangeIndex,
      yearRanges: (0, _getYearRangeChunks.default)(yearRange.min, yearRange.max, yearsToDisplay),
      setYearRangeIndex: this.setYearRangeIndex,
      setYear: this.setYear,
      switchBackToCalendarView: this.switchBackToCalendarView,
      onCancelClick: function onCancelClick() {
        _this3.setState({
          view: CALENDAR
        });

        (0, _reactGa.event)({
          category: GA.category,
          action: GA.actionId + " - Cancel Year"
        });
      },
      GA: GA
    }), view === CALENDAR && _react.default.createElement(_HeaderDayPickerPanel.default, {
      month: month,
      year: year,
      yearRange: yearRange,
      onMonthClick: function onMonthClick() {
        _this3.setState({
          view: MONTH
        });

        (0, _reactGa.event)({
          category: GA.category,
          action: GA.actionId + " - Month Picker"
        });
      },
      onYearClick: function onYearClick() {
        _this3.setState({
          view: YEAR
        });

        (0, _reactGa.event)({
          category: GA.category,
          action: GA.actionId + " - Year Picker"
        });
      },
      setMonth: this.setMonth,
      setYear: this.setYear,
      dateRange: dateRange,
      onApply: function onApply() {
        _this3.applyDatesGaEvent();

        _onApply(range);
      },
      onCancel: onCancel,
      onClear: onClear,
      startDateClicked: startDateClicked,
      disabledDays: disabledDays,
      range: range,
      shortcuts: shortcuts,
      onSelectedDay: this.onSelectedDay,
      GA: GA
    }), close && _react.default.createElement(CloseButton, {
      gaAction: GA.actionId + " Day picker close",
      onClick: close
    }, _react.default.createElement(_Cross.default, {
      size: 16
    })));
  };

  return DayPickerPanel;
}(_react.default.Component);

DayPickerPanel.displayName = 'DayPickerPanel';
var _default = DayPickerPanel;
exports.default = _default;
DayPickerPanel.propTypes = {
  month: _propTypes.number.isRequired,
  year: _propTypes.number.isRequired,
  yearRange: (0, _propTypes.shape)({
    min: _propTypes.number.isRequired,
    max: _propTypes.number.isRequired
  }),
  view: _propTypes.string,
  yearsToDisplay: _propTypes.number,
  dateRange: _propTypes.bool,
  onApply: _propTypes.func.isRequired,
  onCancel: _propTypes.func,
  onClear: _propTypes.func,
  range: (0, _propTypes.shape)({
    from: (0, _propTypes.instanceOf)(Date),
    to: (0, _propTypes.instanceOf)(Date)
  }),
  close: _propTypes.func,
  disabledDays: _propTypes.array,
  // eslint-disable-line react/forbid-prop-types
  shortcuts: (0, _propTypes.oneOf)(['today', 'current', 'last']),
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    actionId: _propTypes.string
  }).isRequired,
  recordValue: _propTypes.bool.isRequired,
  onMonthSelected: _propTypes.func
};
DayPickerPanel.defaultProps = {
  dateRange: false,
  view: CALENDAR,
  yearsToDisplay: null,
  yearRange: {
    min: (0, _brightDates.date)().subtract(1, 'year'),
    max: (0, _brightDates.date)().add(1, 'year')
  },
  range: {
    from: undefined,
    to: undefined
  },
  disabledDays: [],
  close: undefined,
  onCancel: undefined,
  onClear: undefined,
  shortcuts: undefined,
  onMonthSelected: undefined
};